import { DefaultInputPropTypes, EnumDropdown } from 'framework/form';
import { WASTE_STATUSES_OPTIONS } from 'domain/shared/waste';

const WasteStatusDropdown = (props: DefaultInputPropTypes<string>) => {
  return <EnumDropdown options={WASTE_STATUSES_OPTIONS} label="Status" {...props} />;
};

export default WasteStatusDropdown;
